import * as api from "../API/index";
import { authorizedUser } from "components/CommonComponents/CommonFunctions";
import { assessmentArtifactList } from "constants/assessment";

export const createAssessmentArtifact = async (bodyData) => {
  try {
    const res = await api.create_assessment_artifact(bodyData);
    return res?.data;
  } catch (error) {
    authorizedUser(error?.response?.data);
    return error?.response?.data || error;
  }
};

export const updateAssessmentArtifact = async (id, bodyData) => {
  try {
    const res = await api.update_assessment_artifact(id, bodyData);
    return res?.data;
  } catch (error) {
    authorizedUser(error?.response?.data);
    return error?.response?.data || error;
  }
};

export const getAssessmentArtifactById = async (id) => {
  try {
    const res = await api.get_assessment_artifact_by_id(id);
    return res?.data;
  } catch (error) {
    authorizedUser(error?.response?.data);
    return error?.response?.data || error;
  }
};

export const getAssessmentArtifactList = async (dispatch, pageNum, filters, courseId, batchId, traineeId) => {
  try {
    const res = await api.get_assessment_artifact_list(pageNum, filters, courseId, batchId, traineeId);
    dispatch({ type: assessmentArtifactList, payload: res?.data });
    return res?.data;
  } catch (error) {
    authorizedUser(error?.response?.data);
    dispatch({ type: assessmentArtifactList, payload: {} });
    return error?.response?.data || error;
  }
};

export const deleteAssessmentArtifact = async (id) => {
  try {
    const res = await api.delete_assessment_artifact(id);
    return res?.data;
  } catch (error) {
    authorizedUser(error?.response?.data);
    return error?.response?.data || error;
  }
};

export const deleteAssessmentArtifactFile = async (id, fileId) => {
  try {
    const res = await api.delete_assessment_artifact_file(id, fileId);
    return res?.data;
  } catch (error) {
    authorizedUser(error?.response?.data);
    return error?.response?.data || error;
  }
};
